<template>
  <div>
    <v-container style="width:100% !important;">
      <h2 class="">
        {{ $t('Payment Method') }}
        <a href="https://tinyurl.com/4trrbhje" target="blank"
          ><i style="font-size: 18px; color: #ed1e79;" class="fas fa-question-circle"></i
        ></a>
      </h2>

      <v-layout wrap>
        <v-flex xs10>
          <h3>
            {{ $t('Bank Transfer') }}
            <input-boolean-no-label
              v-model="contents.allowtransfer"
              @onInputChange="isTransfer = !isTransfer"
            ></input-boolean-no-label>
          </h3>
        </v-flex>
        <v-flex xs2 class="text-xs-right">
          <v-btn
            fab
            outline
            small
            color="primary"
            v-if="!isEditTransfer"
            @click="isEditTransfer = true"
          >
            <v-icon>edit</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
      <transfer-payment
        :isEdit="isEditTransfer"
        @onSave="isEditTransfer = false"
        :init="contents"
      ></transfer-payment>
    </v-container>

    <v-container style="width:100% !important;">
      <v-layout wrap class="mb-2">
        <v-flex xs9 style="align-self: center;">
          <h2>
            {{ $t('auto_verify_transfer') }}
            <a href="https://blog.zwiz.app/slip-verification/" target="blank"
              ><i style="font-size: 18px; color: #ed1e79;" class="fas fa-question-circle"></i
            ></a>
            <toggle-button
              v-if="$store.getters.getPackage == 'premium'"
              :value="verifyBankActive"
              :sync="true"
              :color="$vuetify.theme.success"
              @change="setVerifyBankActiveToggle"
              :labels="{ checked: 'ON', unchecked: 'OFF' }"
              style="display: inline-block"
            />
          </h2>
          <span>{{ $t('auto_verify_transfer_is_enable') }}</span>
        </v-flex>
        <v-flex xs3 class="text-xs-right" v-if="!dialogVerifyBank">
          <v-btn
            fab
            outline
            small
            color="primary"
            v-if="!dialogVerifyBank && $store.getters.getPackage == 'premium'"
            @click="dialogVerifyBank = true"
          >
            <v-icon>edit</v-icon>
          </v-btn>
          <template v-else>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn readonly fab outline small color="blue" v-on="on">
                  <v-icon>lock</v-icon>
                </v-btn>
              </template>
              <span>{{
                $t(
                  'Upgrade to Premium, starting at 500 baht / month to edit buttons or additional order summary'
                )
              }}</span>
            </v-tooltip>
          </template>
        </v-flex>
      </v-layout>
      <template v-if="dataVerifySlip && dataVerifySlip.length > 0 && !dialogVerifyBank">
        <h3 class="mt-2 mb-1" style="color:#000">{{ $t('payment_method') }}</h3>
        <div
          class="form-control intent-item z-border-red pa-3"
          v-for="(item, index) in dataVerifySlip"
          :key="index"
        >
          <template v-if="item.typeAccount && item.typeAccount.value === 'all'">
            <h4>
              {{ $t('bank_name') }} : <span> {{ $t('not_specified_account') }} </span>
            </h4>
          </template>
          <template v-else>
            <v-layout wrap>
              <v-flex xs2 class="text-xs-center">
                <img
                  v-if="item.bankName && item.bankName === 'promptpay'"
                  style="width: 40px;"
                  :src="'/static/img/assets/payment/logo_e_wallet/ewallet.png'"
                />
                <img
                  v-else
                  style="width: 40px;"
                  :src="
                    getBankName(item.bankName)
                      ? getBankName(item.bankName).image
                      : '/static/img/assets/_global/default-photo.png'
                  "
                />
              </v-flex>
              <v-flex xs10>
                <div>
                  <h4 v-if="item.bankName && item.bankName === 'promptpay'">
                    {{ $t('promptpay') }}
                  </h4>
                  <h4 v-else>
                    {{ $t('bank_name') }} :
                    <span v-if="getBankName(item.bankName)">{{
                      getBankName(item.bankName).name_th
                    }}</span>
                  </h4>
                </div>
                <div style="font-size: 90%;">
                  <span v-if="item.bankName && item.bankName === 'transfer'">
                    {{ $t('bank_account') }} :
                  </span>
                  <span v-else-if="item.bankName && item.bankName === 'promptpay'">
                    {{ $t('promptpay_code') }} :</span
                  >
                  <span v-else> {{ $t('bank_account_no') }} :</span>
                  <span> {{ item.bankAccountNo }}</span>
                  <div>
                    <span> {{ $t('receiver_name_keyword') }} :</span>
                    <template v-if="item.keyword && item.keyword.length > 0">
                      <span v-for="(val, index) in item.keyword" :key="`name_text_${index}`">
                        {{ val.text }}
                        <span v-if="index !== item.keyword.length - 1">,</span></span
                      >
                    </template>
                    <span v-else>-</span>
                  </div>
                </div>
              </v-flex>
            </v-layout>
          </template>
        </div>
      </template>
      <intent-prefill-verify-slip
        v-if="dialogVerifyBank"
        :dialogVerify.sync="dialogVerifyBank"
        :isVerify_slip="true"
        :isPayment="true"
        :keywords.sync="keywords"
        :dataVerifySlip.sync="dataVerifySlip"
        @onAddPrefill="onSaveVerifySlipBank"
        @onClickVerifySlip="onClickVerifySlip"
      ></intent-prefill-verify-slip>
    </v-container>
    <v-divider></v-divider>

    <v-container style="width:100% !important;">
      <h2>
        {{ $t('Credit card') }}
        <template v-if="selectedBot.paypal_merchantid != null">
          <input-boolean-no-label
            v-model="contents.allowcreditcard"
            @onInputChange="isCreditCard = !isCreditCard"
          ></input-boolean-no-label>
        </template>
      </h2>
      <div>
        <div v-if="selectedBot.paypal_merchantid != null">
          {{ $t('Connected with PayPal merchant id') }}:
          <p class="small primary-color">{{ selectedBot.paypal_merchantid }}</p>
        </div>

        <div v-show="!selectedBot.paypal_merchantid">
          <div v-show="!paypal.haveTrackingId">
            <p>{{ $t('to activate credit card payment, please click Link PayPal Account') }}</p>
            <p class="small" style="font-size: 12px;">
              {{
                $t(
                  '(Accept credit/debit card through Paypal channel, with only 3.4% fee for domestic transaction, withdraw to your bank account in 3-5 days)'
                )
              }}
            </p>
            <div v-show="!paypal.loading">
              <div>
                <div style="display:flex;">
                  <div
                    @click="registerPaypalMerchant"
                    style="cursor: pointer;display: table-cell; vertical-align: middle;background: white;overflow: auto;border: 1px solid #b1aeae;border-right: 0; border-top-left-radius: 5px;border-bottom-left-radius: 5px;"
                  >
                    <img
                      src="https://www.paypalobjects.com/webstatic/en_US/i/buttons/PP_logo_h_100x26.png"
                      alt
                      style="padding: 10px 10px;background: #fff;    width: 100%;"
                    />
                  </div>
                  <div
                    @click="registerPaypalMerchant"
                    style="cursor: pointer;background: #002f86;border: 1px solid #b1aeae;border-left: 0; border-top-right-radius: 5px;border-bottom-right-radius: 5px;"
                  >
                    <p
                      style="padding: 15px 15px; margin: 0; max-width: 180px;color: white; white-space: nowrap"
                    >
                      {{ $t('Link PayPal Account') }}
                    </p>
                  </div>
                </div>
                <a
                  href="javascript:void(0);"
                  style="vertical-align: top;display: inline-block;margin-top: 14px;"
                  @click="showHelpRegisterPaypal = true"
                  >{{ $t('how to link PayPal Account?') }}</a
                >
              </div>
            </div>

            <div v-show="paypal.loading">
              <v-progress-circular indeterminate color="primary" size="10"></v-progress-circular>
              {{ $t('Loading') }}
            </div>
          </div>
          <div v-show="paypal.haveTrackingId">
            <div style="margin-bottom: 15px;">
              <template v-if="paypal.checkTracking">
                <sync-loader
                  :color="$vuetify.theme.primary"
                  :size="'10px'"
                  style="display:inline-block;margin-right: 10px"
                ></sync-loader>
                <span style="display:inline">{{
                  $t('Pending PayPal Merchant Account Registration')
                }}</span>
              </template>
              <template v-else>
                <a href="javascript:void(0);" @click="onRefreshTrackingStatus">
                  <i class="fas fa-sync-alt"></i>
                  {{ $t('Click refresh after you have completed registration') }}
                </a>
              </template>
              |
              <a href="javascript:void(0);" @click="cancelRegisterPaypalMerchant">{{
                $t('cancel')
              }}</a>
            </div>
          </div>

          <modal-dialog v-if="showHelpRegisterPaypal" @close="showHelpRegisterPaypal = false">
            <span slot="header"></span>

            <div slot="body">
              <h2 class="text-xs-center pt-4">{{ $t('How to link PayPal Account') }}</h2>
              <div style="margin-top: 15px;margin-bottom: 25px;text-align: center">
                <p style="padding: 0 15px">{{ $t('1. Click Link PayPal Account button') }}</p>
                <img
                  src="/static/img/assets/setting/register_paypal/step1.png"
                  style="width: 100%; margin: auto"
                  alt
                />
              </div>
              <div class="hr"></div>
              <div style="margin-top: 15px;margin-bottom: 25px;text-align: center">
                <p style="padding: 0 15px">
                  {{ $t('2. input email and select Thailand and then click on Next button') }}
                </p>
                <img
                  src="/static/img/assets/setting/register_paypal/step2.png"
                  style="width: 100%; margin: auto"
                  alt
                />
              </div>
              <div class="hr"></div>
              <div style="margin-top: 15px;margin-bottom: 25px;text-align: center">
                <p style="padding: 0 15px">
                  {{ $t('3. complete details in form (select Thailand, and THB only)') }}
                </p>
                <img
                  src="/static/img/assets/setting/register_paypal/step3.png"
                  style="width: 100%; margin: auto"
                  alt
                />
              </div>
              <div class="hr"></div>
              <div style="margin-top: 15px;margin-bottom: 25px;text-align: center">
                <p style="padding: 0 15px">
                  {{ $t('4. Accept to connect with Robolingo Co., Ltd.') }}
                </p>
                <img
                  src="/static/img/assets/setting/register_paypal/step4.png"
                  style="width: 100%; margin: auto"
                  alt
                />
              </div>
              <div class="hr"></div>
              <div style="margin-top: 15px;margin-bottom: 25px;text-align: center">
                <p style="padding: 0 15px">
                  {{ $t('5. verify e-mail and click ใช่ นี่คือที่อยู่อีเมลของฉัน button') }}
                </p>
                <img
                  src="/static/img/assets/setting/register_paypal/step4_1.png"
                  style="width: 100%; margin: auto"
                  alt
                />
              </div>
              <div class="hr"></div>
              <div style="margin-top: 15px;margin-bottom: 25px;text-align: center">
                <p style="padding: 0 15px">
                  {{
                    $t(
                      '6. Wait for processing and click Try to get PayPal merchant id again button to check connection with PayPal'
                    )
                  }}
                </p>
                <img
                  src="/static/img/assets/setting/register_paypal/step5.png"
                  style="width: 100%; margin: auto"
                  alt
                />
              </div>
              <div class="hr"></div>
              <div style="margin-top: 15px;margin-bottom: 25px;text-align: center">
                <p style="padding: 0 15px">
                  {{
                    $t(
                      '7. After you register successfully you will see merchant id on this page. If you can not register, please contact'
                    )
                  }}
                  <a :href="'mailto:' + $store.state.theme.email_contact">{{
                    $store.state.theme.email_contact
                  }}</a>
                </p>
                <img
                  src="/static/img/assets/setting/register_paypal/step6.png"
                  style="max-width: 300px; width: 100%; margin: auto"
                  alt
                />
              </div>
            </div>

            <div slot="footer">
              <div class="row text-xs-center">
                <a
                  href="javascript:void(0);"
                  class="btn btn-primary"
                  @click="showHelpRegisterPaypal = false"
                  >{{ $t('cancel') }}</a
                >
              </div>
            </div>
          </modal-dialog>
        </div>
      </div>
    </v-container>
    <v-divider></v-divider>
    <template v-if="selectedBot.packages.includes('facebook')">
      <v-container style="width:100% !important;">
        <fbpay-payment class="my-5"></fbpay-payment>
      </v-container>
      <v-divider></v-divider>
    </template>

    <!-- <v-container style="max-width: 1000px">
      <h2 class="text-xs-left headline nunito" style="text-shadow: rgba(0, 0, 0, 0.4) 0px 3px 6px;">
        <span style="color:#FF706B;">CHAT</span>
        <span style="color: white;">2</span>
        <span style="color:#004071">PAY</span>
      </h2>

      <div>
        ระบบ Chat2Pay เปิดบิลผ่านแชทง่ายๆ เพียงพิมพ์หาลูกค้าว่า เปิดบิล ตามด้วยรายละเอียด และ
        ราคาสินค้า ระบบจะส่งลิงก์จ่ายเงินไปให้ลูกค้าทันที สมัครฟรีวันนี้
      </div>
      <v-btn
        depressed
        color="primary"
        :to="'/' + currentLang + '/setup_c2p?source=zwiz'"
        class="ma-0 mt-2 mb-5"
        >Register Chat2Pay</v-btn
      >
    </v-container>
    <v-divider></v-divider> -->

    <template v-if="selectedBot.pagetype != 'enterprise'">
      <v-container style="width:100% !important;">
        <gbprime-payment class="my-5"></gbprime-payment>
      </v-container>
      <v-divider></v-divider>
    </template>

    <v-container style="max-width: 1000px"> </v-container>

    <div class="mb-5 mt-5"></div>
  </div>
</template>

<script>
import InputBooleanNoLabel from '@/components/view/setting/input-no-label/InputBooleanNoLabel'
import TransferPayment from '@/components/view/setting/ecommerce/TransferPayment'
import PreviewMessage from '@/components/elements/PreviewMessage'
import { mapGetters } from 'vuex'
import api from '@/api'
import ModalDialog from '@/components/elements/ModalDialog'
import Tags from '@/components/elements/Tags'
import Swatches from 'vue-swatches'
import 'vue-swatches/dist/vue-swatches.min.css'
import Multiselect from 'vue-multiselect'
import ViewCartSummaryViewer from '@/components/elements/ViewCartSummaryViewer'
import ViewReceiptViewer from '@/components/elements/ViewReceiptViewer'
import specialtext from '@/components/elements/specialtext'
import IntentPrefill from '@/components/view/intent/IntentPrefill'
import AutoresizeTextarea from '@/components/elements/AutoresizeTextarea'
import ShopProfile from '@/components/view/setting/ecommerce/ShopProfile'
import FbpayPayment from './FbpayPayment'
import GbprimePayment from './GbprimePayment'
import TaxInvoice from './TaxInvoice'
import ShopOption from '@/components/view/setting/ecommerce/ShopOption'
import { ToggleButton } from 'vue-js-toggle-button'
import IntentGroup from '@/components/view/intent/IntentGroup'
import MessageViewer from '@/components/elements/MessageViewer'
import TimePicker from '@/components/elements/TimePicker.vue'
import IntentPrefillVerifySlip from '@/components/view/intent/IntentPrefillVerifySlip'
import IntentGroupItem from '@/components/view/intent/IntentGroupItem.js'
import dayjs from 'dayjs'
import { cloneDeep } from 'lodash'

export default {
  data: function() {
    return {
      keywords: [],
      dialogVerifyBank: false,
      verifyBankActive: false,
      dataVerifySlip: [],
      timestamp: dayjs().format('x'),
      showMultipleChannel: false,
      showMultipleChannelFollowUp: false,
      errorTag: {
        replies: [],
        facebook: [],
        line: [],
        ig: [],
        whatsapp: [],
        google: [],
        follow_up_cart_fb_quick_reply: [],
        follow_up_cart_line_quick_reply: [],
        follow_up_cart_ig_quick_reply: [],
        follow_up_cart_whatsapp_quick_reply: [],
        follow_up_cart_google_quick_reply: [],
        follow_up_cart_whatsapp_quick_reply: [],
        follow_up_cart_quick_reply: [],
        follow_up_order_quick_reply: [],
        follow_up_order_fb_quick_reply: [],
        follow_up_order_line_quick_reply: [],
        follow_up_order_ig_quick_reply: [],
        follow_up_order_whatsapp_quick_reply: [],
        follow_up_order_google_quick_reply: []
      },
      follow_up_cart_reply: '',
      follow_up_order_reply: '',
      showPreview: false,
      showPreview2: false,
      tab: 'all',
      tab2: 'all',
      messages: [[]],
      messages2: [[]],
      fb_messages: [[]],
      fb_messages2: [[]],
      line_messages: [[]],
      line_messages2: [[]],
      ig_messages: [[]],
      ig_messages2: [[]],
      whatsapp_messages: [[]],
      whatsapp_messages2: [[]],
      google_messages: [[]],
      google_messages2: [[]],
      whatsapp_messages: [[]],
      whatsapp_messages2: [[]],
      toggle: false,
      is_hide_add_more_btn: false,
      setShopOption: false,
      EditAddress: false,
      shopOption: [
        { label: 'Name', is_require: true, type: 'text', id: '0', message: '' },
        { label: 'Shipping Address', is_require: true, type: 'text', id: '1', message: '' },
        { label: 'Email Address', is_require: true, type: 'email', id: '2', message: '' },
        { label: '', is_require: true, type: 'text', id: '3', message: '' },
        {
          label: 'Tel.',
          is_require: true,
          type: 'text',
          id: '4',
          message: '',
          requiredNineCharacter: true,
          requiredTenCharacter: true
        }
      ],
      isEditShopOption: false,

      isEditPaymentDetail: false,
      isEditShop: false,
      isEditTransfer: false,
      isEditOrderSummaryMessage: false,
      contents: {},
      isTransfer: false,
      isCreditCard: false,
      paypal: {
        paypal_url: null,
        tracking_id: null,
        loading: true,
        checkTracking: false,
        haveTrackingId: false,

        checkingInterval: null,
        checkingTime: 4,
        checkingTimePerInterval: 5000
      },
      profile: {},
      oldProfile: {},
      showHelpRegisterPaypal: false,
      color: '#1CA085',
      lang: {
        value: 'th',
        flag: 'th',
        label: 'Thai'
      },
      langOptions: [
        {
          value: 'en',
          flag: 'gb',
          label: 'English'
        },
        {
          value: 'th',
          flag: 'th',
          label: 'Thai'
        },
        {
          value: 'la',
          flag: 'la',
          label: 'Laos'
        }
      ],
      wordafter: {
        loading: true,
        wordscartsummary: {
          type: 'text',
          text: ''
        },
        wordsorders: {
          type: 'text',
          text: ''
        }
      },
      lineMyShopActive: false,
      values: [
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18,
        19,
        20,
        21,
        22,
        23,
        24,
        25,
        26,
        27,
        28,
        29,
        30
      ],
      facebook_status: false,
      line_status: false,
      ig_status: false,
      google_status: false
    }
  },
  components: {
    Tags,
    PreviewMessage,
    ToggleButton,
    ShopOption,
    TaxInvoice,
    InputBooleanNoLabel,
    TransferPayment,
    IntentGroup,
    ModalDialog,
    Swatches,
    Multiselect,
    ViewCartSummaryViewer,
    ViewReceiptViewer,
    specialtext,
    IntentPrefill,
    AutoresizeTextarea,
    ShopProfile,
    FbpayPayment,
    GbprimePayment,
    MessageViewer,
    TimePicker,
    IntentPrefillVerifySlip
  },
  mixins: [IntentGroupItem],
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      paypalTrackingId: 'paypalTrackingId',
      currentLang: 'currentLang',
      getPageProfile: 'getPageProfile'
    }),

    quickReplyPreview2: function() {
      let reply = ''
      const vm = this
      if (vm.tab2 == 'all') {
        reply = vm.follow_up_order_quick_reply
      } else if (vm.tab2 == 'facebook') {
        reply = vm.follow_up_order_fb_quick_reply
      } else if (vm.tab2 == 'line') {
        reply = vm.follow_up_order_line_quick_reply
      } else if (vm.tab2 == 'instagram') {
        reply = vm.follow_up_order_ig_quick_reply
      } else if (vm.tab2 == 'whatsapp') {
        reply = vm.follow_up_order_whatsapp_quick_reply
      } else if (vm.tab2 == 'google') {
        reply = vm.follow_up_order_google_quick_reply
      }
      return reply
    },

    quickReplyPreview: function() {
      let reply = ''
      const vm = this
      if (vm.tab == 'all') {
        reply = vm.follow_up_cart_quick_reply
      } else if (vm.tab == 'facebook') {
        reply = vm.follow_up_cart_fb_quick_reply
      } else if (vm.tab == 'line') {
        reply = vm.follow_up_cart_line_quick_reply
      } else if (vm.tab == 'instagram') {
        reply = vm.follow_up_cart_ig_quick_reply
      } else if (vm.tab == 'whatsapp') {
        reply = vm.follow_up_cart_whatsapp_quick_reply
      } else if (vm.tab == 'google') {
        reply = vm.follow_up_cart_google_quick_reply
      }
      return reply
    },

    messagesPreview: function() {
      let messages = [[]]
      const vm = this
      if (vm.tab == 'all') {
        messages = vm.messages
      } else if (vm.tab == 'facebook') {
        messages = vm.fb_messages
      } else if (vm.tab == 'line') {
        messages = vm.line_messages
      } else if (vm.tab == 'instagram') {
        messages = vm.ig_messages
      } else if (vm.tab == 'whatsapp') {
        messages = vm.whatsapp_messages
      } else if (vm.tab == 'google') {
        messages = vm.google_messages
      } else if (this.tab == 'whatsapp') {
        messages = this.whatsapp_messages
      }
      return messages
    },

    messagesPreview2: function() {
      let messages2 = [[]]
      const vm = this
      if (vm.tab2 == 'all') {
        messages2 = vm.messages2
      } else if (vm.tab2 == 'facebook') {
        messages2 = vm.fb_messages2
      } else if (vm.tab2 == 'line') {
        messages2 = vm.line_messages2
      } else if (vm.tab2 == 'instagram') {
        messages2 = vm.ig_messages2
      } else if (vm.tab2 == 'whatsapp') {
        messages2 = vm.whatsapp_messages2
      } else if (vm.tab2 == 'google') {
        messages2 = vm.google_messages2
      } else if (this.tab2 == 'whatsapp') {
        messages2 = this.whatsapp_messages2
      }
      return messages2
    },

    replies: function() {
      let reply = ''
      const vm = this
      if (vm.tab == 'all') {
        reply = vm.wordafter.follow_up_cart_quick_reply
      } else if (vm.tab == 'facebook') {
        reply = vm.wordafter.follow_up_cart_fb_quick_reply
      } else if (vm.tab == 'line') {
        reply = vm.wordafter.follow_up_cart_line_quick_reply
      } else if (vm.tab == 'instagram') {
        reply = vm.wordafter.follow_up_cart_ig_quick_reply
      } else if (vm.tab == 'whatsapp') {
        reply = vm.wordafter.follow_up_cart_whatsapp_quick_reply
      } else if (vm.tab == 'google') {
        reply = vm.wordafter.follow_up_cart_google_quick_reply
      } else if (this.tab == 'whatsapp') {
        reply = this.wordafter.follow_up_cart_whatsapp_quick_reply
      }
      if (reply && reply !== '' && reply != null) {
        const replies = reply.split(',')
        return replies
      } else {
        return []
      }
    },

    follow_up_quick_reply: function() {
      let reply = ''
      const vm = this
      if (vm.tab2 == 'all') {
        reply = vm.wordafter.follow_up_order_quick_reply
      } else if (vm.tab2 == 'facebook') {
        reply = vm.wordafter.follow_up_order_fb_quick_reply
      } else if (vm.tab2 == 'line') {
        reply = vm.wordafter.follow_up_order_line_quick_reply
      } else if (vm.tab2 == 'instagram') {
        reply = vm.wordafter.follow_up_order_ig_quick_reply
      } else if (vm.tab2 == 'whatsapp') {
        reply = vm.wordafter.follow_up_order_whatsapp_quick_reply
      } else if (vm.tab2 == 'google') {
        reply = vm.wordafter.follow_up_order_google_quick_reply
      } else if (this.tab2 == 'whatsapp') {
        reply = this.wordafter.follow_up_order_whatsapp_quick_reply
      }
      if (reply && reply !== '' && reply != null) {
        const replies = reply.split(',')
        return replies
      } else {
        return []
      }
    },

    follow_up_cart_quick_reply: {
      get() {
        let vm = this
        if (
          vm.wordafter &&
          vm.wordafter.follow_up_cart_quick_reply &&
          vm.wordafter.follow_up_cart_quick_reply !== ''
        ) {
          var quick_replies = []
          quick_replies = vm.wordafter.follow_up_cart_quick_reply.split(',')

          var result = []
          try {
            result = quick_replies.map(val => {
              return { text: val }
            })
          } catch (error) {}
          return result
        } else {
          return []
        }
      },
      set(value) {
        const vm = this
        let result = []
        try {
          result = value.map(el => {
            return el.text
          })
        } catch (error) {
          console.log(error)
        }
        vm.$set(vm.wordafter, 'follow_up_cart_quick_reply', result.join(','))
      }
    },

    follow_up_cart_fb_quick_reply: {
      get() {
        let vm = this
        if (
          vm.wordafter &&
          vm.wordafter.follow_up_cart_fb_quick_reply &&
          vm.wordafter.follow_up_cart_fb_quick_reply !== ''
        ) {
          // console.log(vm.intent.fb_quick_reply)
          var quick_replies = []

          if (vm.wordafter.a_type === 'message' || vm.wordafter.a_type === 'generic') {
            if (vm.setting.welcome_quickreplies) {
              quick_replies = vm.setting.welcome_quickreplies.contentvalue.split(',')
            }
          } else {
            quick_replies = vm.wordafter.follow_up_cart_fb_quick_reply.split(',')
          }
          var result = []
          try {
            result = quick_replies.map(val => {
              return { text: val }
            })
          } catch (error) {}
          return result
        } else {
          return []
        }
      },
      set(value) {
        var result = []
        try {
          result = value.map(el => {
            return el.text
          })
        } catch (error) {}
        this.$set(this.wordafter, 'follow_up_cart_fb_quick_reply', result.join(','))
      }
    },
    follow_up_cart_line_quick_reply: {
      get() {
        let vm = this
        if (
          vm.wordafter &&
          vm.wordafter.follow_up_cart_line_quick_reply &&
          vm.wordafter.follow_up_cart_line_quick_reply !== ''
        ) {
          // console.log(vm.intent.line_quick_reply)
          var quick_replies = []

          if (vm.wordafter.a_type === 'message' || vm.wordafter.a_type === 'generic') {
            if (vm.setting.welcome_quickreplies) {
              quick_replies = vm.setting.welcome_quickreplies.contentvalue.split(',')
            }
          } else {
            quick_replies = vm.wordafter.follow_up_cart_line_quick_reply.split(',')
          }
          var result = []
          try {
            result = quick_replies.map(val => {
              return { text: val }
            })
          } catch (error) {}
          return result
        } else {
          return []
        }
      },
      set(value) {
        var result = []
        try {
          result = value.map(el => {
            return el.text
          })
        } catch (error) {}
        this.$set(this.wordafter, 'follow_up_cart_line_quick_reply', result.join(','))
      }
    },
    follow_up_cart_ig_quick_reply: {
      get() {
        let vm = this
        if (
          vm.wordafter &&
          vm.wordafter.follow_up_cart_ig_quick_reply &&
          vm.wordafter.follow_up_cart_ig_quick_reply !== ''
        ) {
          // console.log(vm.intent.ig_quick_reply)
          var quick_replies = []

          if (vm.wordafter.a_type === 'message' || vm.wordafter.a_type === 'generic') {
            if (vm.setting.welcome_quickreplies) {
              quick_replies = vm.setting.welcome_quickreplies.contentvalue.split(',')
            }
          } else {
            quick_replies = vm.wordafter.follow_up_cart_ig_quick_reply.split(',')
          }
          var result = []
          try {
            result = quick_replies.map(val => {
              return { text: val }
            })
          } catch (error) {}
          return result
        } else {
          return []
        }
      },
      set(value) {
        var result = []
        try {
          result = value.map(el => {
            return el.text
          })
        } catch (error) {}
        this.$set(this.wordafter, 'follow_up_cart_ig_quick_reply', result.join(','))
      }
    },
    follow_up_cart_google_quick_reply: {
      get() {
        let vm = this
        if (
          vm.wordafter &&
          vm.wordafter.follow_up_cart_google_quick_reply &&
          vm.wordafter.follow_up_cart_google_quick_reply !== ''
        ) {
          // console.log(vm.intent.ig_quick_reply)
          var quick_replies = []

          if (vm.wordafter.a_type === 'message' || vm.wordafter.a_type === 'generic') {
            if (vm.setting.welcome_quickreplies) {
              quick_replies = vm.setting.welcome_quickreplies.contentvalue.split(',')
            }
          } else {
            quick_replies = vm.wordafter.follow_up_cart_google_quick_reply.split(',')
          }
          var result = []
          try {
            result = quick_replies.map(val => {
              return { text: val }
            })
          } catch (error) {}
          return result
        } else {
          return []
        }
      },
      set(value) {
        var result = []
        try {
          result = value.map(el => {
            return el.text
          })
        } catch (error) {}
        this.$set(this.wordafter, 'follow_up_cart_google_quick_reply', result.join(','))
      }
    },
    follow_up_cart_quick_reply_show: function() {
      var reply = ''
      reply = this.wordafter.follow_up_cart_quick_reply
      if (reply && reply !== '' && reply != null) {
        var replies = reply.split(',')
        return replies
      } else {
        return []
      }
    },
    follow_up_order_quick_reply_show: function() {
      var reply = ''
      reply = this.wordafter.follow_up_order_quick_reply
      if (reply && reply !== '' && reply != null) {
        var replies = reply.split(',')
        return replies
      } else {
        return []
      }
    },
    follow_up_cart_google_quick_reply: {
      get() {
        let vm = this
        if (
          vm.wordafter &&
          vm.wordafter.follow_up_cart_google_quick_reply &&
          vm.wordafter.follow_up_cart_google_quick_reply !== ''
        ) {
          // console.log(vm.intent.ig_quick_reply)
          var quick_replies = []

          if (vm.wordafter.a_type === 'message' || vm.wordafter.a_type === 'generic') {
            if (vm.setting.welcome_quickreplies) {
              quick_replies = vm.setting.welcome_quickreplies.contentvalue.split(',')
            }
          } else {
            quick_replies = vm.wordafter.follow_up_cart_google_quick_reply.split(',')
          }
          var result = []
          try {
            result = quick_replies.map(val => {
              return { text: val }
            })
          } catch (error) {}
          return result
        } else {
          return []
        }
      },
      set(value) {
        var result = []
        try {
          result = value.map(el => {
            return el.text
          })
        } catch (error) {}
        this.$set(this.wordafter, 'follow_up_cart_google_quick_reply', result.join(','))
      }
    },
    follow_up_cart_whatsapp_quick_reply: {
      get() {
        let vm = this
        if (
          vm.wordafter &&
          vm.wordafter.follow_up_cart_whatsapp_quick_reply &&
          vm.wordafter.follow_up_cart_whatsapp_quick_reply !== ''
        ) {
          // console.log(vm.intent.ig_quick_reply)
          var quick_replies = []

          if (vm.wordafter.a_type === 'message' || vm.wordafter.a_type === 'generic') {
            if (vm.setting.welcome_quickreplies) {
              quick_replies = vm.setting.welcome_quickreplies.contentvalue.split(',')
            }
          } else {
            quick_replies = vm.wordafter.follow_up_cart_whatsapp_quick_reply.split(',')
          }
          var result = []
          try {
            result = quick_replies.map(val => {
              return { text: val }
            })
          } catch (error) {}
          return result
        } else {
          return []
        }
      },
      set(value) {
        var result = []
        try {
          result = value.map(el => {
            return el.text
          })
        } catch (error) {}
        this.$set(this.wordafter, 'follow_up_cart_whatsapp_quick_reply', result.join(','))
      }
    },
    follow_up_cart_quick_reply_show: function() {
      var reply = ''
      reply = this.wordafter.follow_up_cart_quick_reply
      if (reply && reply !== '' && reply != null) {
        var replies = reply.split(',')
        return replies
      } else {
        return []
      }
    },
    follow_up_order_quick_reply_show: function() {
      var reply = ''
      reply = this.wordafter.follow_up_order_quick_reply
      if (reply && reply !== '' && reply != null) {
        var replies = reply.split(',')
        return replies
      } else {
        return []
      }
    },
    follow_up_order_quick_reply: {
      get() {
        let vm = this
        if (
          vm.wordafter &&
          vm.wordafter.follow_up_order_quick_reply &&
          vm.wordafter.follow_up_order_quick_reply !== ''
        ) {
          var quick_replies = []
          quick_replies = vm.wordafter.follow_up_order_quick_reply.split(',')

          var result = []
          try {
            result = quick_replies.map(val => {
              return { text: val }
            })
          } catch (error) {}
          return result
        } else {
          return []
        }
      },
      set(value) {
        var result = []
        try {
          result = value.map(el => {
            return el.text
          })
        } catch (error) {}
        this.$set(this.wordafter, 'follow_up_order_quick_reply', result.join(','))
      }
    },

    follow_up_order_fb_quick_reply: {
      get() {
        let vm = this
        if (
          vm.wordafter &&
          vm.wordafter.follow_up_order_fb_quick_reply &&
          vm.wordafter.follow_up_order_fb_quick_reply !== ''
        ) {
          // console.log(vm.intent.fb_quick_reply)
          var quick_replies = []

          if (vm.wordafter.a_type === 'message' || vm.wordafter.a_type === 'generic') {
            if (vm.setting.welcome_quickreplies) {
              quick_replies = vm.setting.welcome_quickreplies.contentvalue.split(',')
            }
          } else {
            quick_replies = vm.wordafter.follow_up_order_fb_quick_reply.split(',')
          }
          var result = []
          try {
            result = quick_replies.map(val => {
              return { text: val }
            })
          } catch (error) {}
          return result
        } else {
          return []
        }
      },
      set(value) {
        var result = []
        try {
          result = value.map(el => {
            return el.text
          })
        } catch (error) {}
        this.$set(this.wordafter, 'follow_up_order_fb_quick_reply', result.join(','))
      }
    },
    follow_up_order_line_quick_reply: {
      get() {
        let vm = this
        if (
          vm.wordafter &&
          vm.wordafter.follow_up_order_line_quick_reply &&
          vm.wordafter.follow_up_order_line_quick_reply !== ''
        ) {
          // console.log(vm.intent.line_quick_reply)
          var quick_replies = []

          if (vm.wordafter.a_type === 'message' || vm.wordafter.a_type === 'generic') {
            if (vm.setting.welcome_quickreplies) {
              quick_replies = vm.setting.welcome_quickreplies.contentvalue.split(',')
            }
          } else {
            quick_replies = vm.wordafter.follow_up_order_line_quick_reply.split(',')
          }
          var result = []
          try {
            result = quick_replies.map(val => {
              return { text: val }
            })
          } catch (error) {}
          return result
        } else {
          return []
        }
      },
      set(value) {
        var result = []
        try {
          result = value.map(el => {
            return el.text
          })
        } catch (error) {}
        this.$set(this.wordafter, 'follow_up_order_line_quick_reply', result.join(','))
      }
    },
    follow_up_order_ig_quick_reply: {
      get() {
        let vm = this
        if (
          vm.wordafter &&
          vm.wordafter.follow_up_order_ig_quick_reply &&
          vm.wordafter.follow_up_order_ig_quick_reply !== ''
        ) {
          // console.log(vm.intent.ig_quick_reply)
          var quick_replies = []

          if (vm.wordafter.a_type === 'message' || vm.wordafter.a_type === 'generic') {
            if (vm.setting.welcome_quickreplies) {
              quick_replies = vm.setting.welcome_quickreplies.contentvalue.split(',')
            }
          } else {
            quick_replies = vm.wordafter.follow_up_order_ig_quick_reply.split(',')
          }
          var result = []
          try {
            result = quick_replies.map(val => {
              return { text: val }
            })
          } catch (error) {}
          return result
        } else {
          return []
        }
      },
      set(value) {
        var result = []
        try {
          result = value.map(el => {
            return el.text
          })
        } catch (error) {}
        this.$set(this.wordafter, 'follow_up_order_ig_quick_reply', result.join(','))
      }
    },
    follow_up_order_whatsapp_quick_reply: {
      get() {
        const vm = this
        if (
          vm.wordafter &&
          vm.wordafter.follow_up_order_whatsapp_quick_reply &&
          vm.wordafter.follow_up_order_whatsapp_quick_reply !== ''
        ) {
          // console.log(vm.intent.ig_quick_reply)
          var quick_replies = []

          if (vm.wordafter.a_type === 'message' || vm.wordafter.a_type === 'generic') {
            if (vm.setting.welcome_quickreplies) {
              quick_replies = vm.setting.welcome_quickreplies.contentvalue.split(',')
            }
          } else {
            quick_replies = vm.wordafter.follow_up_order_whatsapp_quick_reply.split(',')
          }
          var result = []
          try {
            result = quick_replies.map(val => {
              return { text: val }
            })
          } catch (error) {}
          return result
        } else {
          return []
        }
      },
      set(value) {
        const vm = this
        let result = []
        try {
          result = value.map(el => {
            return el.text
          })
        } catch (error) {}
        vm.$set(vm.wordafter, 'follow_up_order_whatsapp_quick_reply', result.join(','))
      }
    },
    follow_up_order_google_quick_reply: {
      get() {
        let vm = this
        if (
          vm.wordafter &&
          vm.wordafter.follow_up_order_google_quick_reply &&
          vm.wordafter.follow_up_order_google_quick_reply !== ''
        ) {
          // console.log(vm.intent.ig_quick_reply)
          var quick_replies = []

          if (vm.wordafter.a_type === 'message' || vm.wordafter.a_type === 'generic') {
            if (vm.setting.welcome_quickreplies) {
              quick_replies = vm.setting.welcome_quickreplies.contentvalue.split(',')
            }
          } else {
            quick_replies = vm.wordafter.follow_up_order_google_quick_reply.split(',')
          }
          var result = []
          try {
            result = quick_replies.map(val => {
              return { text: val }
            })
          } catch (error) {}
          return result
        } else {
          return []
        }
      },
      set(value) {
        const vm = this
        let result = []
        try {
          result = value.map(el => {
            return el.text
          })
        } catch (error) {}
        vm.$set(vm.wordafter, 'follow_up_order_google_quick_reply', result.join(','))
      }
    }
  },
  created: function() {
    var vm = this
    vm.getWordAfterOrderAndCartSummary()
    vm.paypal.haveTrackingId = vm.paypalTrackingId != null
    vm.paypal.checkTracking = vm.paypal.haveTrackingId && vm.selectedBot.paypal_merchantid == null
    vm.$store.dispatch('loadCharges')
    vm.$store.dispatch('loadSetting')
    vm.$store.dispatch('loadPageProfile')
    vm.getSetting()
    vm.getShopProfile()
    if (vm.selectedBot.theme === 'ecommercebasic') {
      vm.$store.dispatch('loadCategory')
      vm.$store.dispatch('loadProducts')
      if (vm.selectedBot.paypal_merchantid == null) {
        if (vm.paypalTrackingId == null) {
          vm.getPaypalUrl()
        } else {
          if (vm.paypal.checkTracking) {
            vm.onRefreshTrackingStatus()
          }
        }
      }
    }
  },
  mounted: function() {
    const vm = this
    vm.EditAddress = vm.selectedBot.is_allow_user_edit_order
    vm.is_hide_add_more_btn = vm.selectedBot.is_hide_add_more_btn
    if (vm.selectedBot.shop_addon_form_json) {
      vm.shopOption = JSON.parse(vm.selectedBot.shop_addon_form_json)
      vm.setShopOption = vm.selectedBot.shop_addon_form_status
    }
    vm.verifyBankActive = vm.selectedBot.verify_slip_is_active
    try {
      if (vm.selectedBot.line_my_shop_is_active && vm.selectedBot.line_my_shop_api_key) {
        vm.lineMyShopActive = true
      } else {
        vm.lineMyShopActive = false
      }
    } catch (err) {
      console.log(err)
    }
    try {
      if (vm.selectedBot.verify_slip_config) {
        vm.isVerify_slip = true
        const textSplitValue = vm.selectedBot.verify_slip_config.split(',')
        const dataValue = textSplitValue[0].split('^')
        dataValue[dataValue.length - 1] = dataValue[dataValue.length - 1].split('}')[0]
        dataValue.map((item, index) => {
          let typeAccount = null
          if (item.split('|')[0] === 'promptpay') {
            typeAccount = { value: 'promptpay', label: 'Promptpay' }
          } else if (item.split('|')[0].includes('ew')) {
            typeAccount = { value: 'eWallet', label: 'E-Wallet' }
          } else if (item.split('|')[0].includes('pg')) {
            typeAccount = { value: 'paymentGateway', label: 'Payment Gateway' }
          } else {
            typeAccount = { value: 'transfer', label: 'Transfer' }
          }
          let keyword = []
          if (item.split('|') && item.split('|')[2]) {
            item
              .split('|')[2]
              .split('!')
              .forEach(element => {
                keyword.push({ text: element })
              })
          }
          vm.dataVerifySlip.push({
            id: `${dayjs().format('x')}_${index}`,
            typeAccount: typeAccount,
            bankAccountNo: item.split('|')[1],
            bankName: item.split('|')[0],
            keyword: keyword
          })
        })
      }
    } catch (error) {
      console.error(error)
    }
    const packages = vm.selectedBot.packages
    vm.facebook_status = packages.includes('facebook') ? true : false
    vm.ig_status = packages.includes('instagram') ? true : false
    vm.line_status = packages.includes('line') ? true : false
    vm.google_status = packages.includes('google') ? true : false
  },
  methods: {
    setVerifyBankActiveToggle() {
      this.verifyBankActive = !this.verifyBankActive
      this.putConfigVerifySlip()
    },
    getBankName(bankName) {
      const vm = this
      let bankAlltype = vm.$store.state.bankForVerify.concat(vm.$store.state.eWalletForVerify)
      bankAlltype = bankAlltype.concat(vm.$store.state.paymentGateway)
      return bankAlltype.filter(bankInfo => bankInfo.value === bankName)[0]
    },
    async putConfigVerifySlip(payload) {
      const vm = this
      vm.$store.dispatch('loading')
      const data = {
        verify_slip_is_active: vm.verifyBankActive,
        verify_slip_config: payload ? payload.replace(',{verify_slip.image}', '') : null // replace for bug verify slip
      }

      let response = await vm.put(`page/${vm.selectedBot.pageid}/update-page-config`, data)
      if (response.success) {
        this.$store.dispatch('updateBotDetail')
      }
      vm.$store.dispatch('loading')
    },
    onSaveVerifySlipBank(payload) {
      const vm = this
      vm.dataVerifySlip = []
      let dataToPut = null
      if (payload.includes('{verify_slip.bank_info')) {
        try {
          const textSplitValue = payload.split('{verify_slip.bank_info=')
          const textSplitValue2 = textSplitValue[1].split(',')
          const dataValue = textSplitValue2[0].split('^')
          dataValue[dataValue.length - 1] = dataValue[dataValue.length - 1].split('}')[0]
          dataValue.map(item => {
            let typeAccount = null
            if (item.split('|')[0] === 'promptpay') {
              typeAccount = { value: 'promptpay', label: 'Promptpay' }
            } else if (item.split('|')[0].includes('ew')) {
              typeAccount = { value: 'eWallet', label: 'E-Wallet' }
            } else if (item.split('|')[0].includes('pg') || item.split('|')[0] === 'pgother') {
              typeAccount = { value: 'paymentGateway', label: 'Payment Gateway' }
            } else {
              typeAccount = { value: 'transfer', label: 'Transfer' }
            }
            let keyword = []
            if (item.split('|') && item.split('|')[2]) {
              item
                .split('|')[2]
                .split('!')
                .forEach(element => {
                  keyword.push({ text: element })
                })
            }
            if (item.split('|')[0]) {
              vm.dataVerifySlip.push({
                id: dayjs().format('x'),
                typeAccount: typeAccount,
                bankAccountNo: item.split('|')[1],
                bankName: item.split('|')[0],
                keyword: keyword
              })
            }
          })
          dataToPut = textSplitValue[1].split('},{verify_slip.name_keywords')[0]
        } catch (error) {
          console.error(error)
        }
      }
      vm.putConfigVerifySlip(dataToPut)
    },
    onClickVerifySlip() {
      const vm = this
      vm.dialogVerifyBank = false
    },
    async changeSettingFollowUp(payload) {
      const vm = this
      if (
        (vm.$store.getters.getPackage == 'premium' || vm.selectedBot.pagetype == 'enterprise') &&
        payload.hasOwnProperty('showMultipleChannel')
      ) {
        if (
          vm.showMultipleChannelFollowUp != payload.showMultipleChannel &&
          payload.showMultipleChannel == true
        ) {
          var fb_messages2 = cloneDeep(vm.messages2)
          vm.fb_messages2 = fb_messages2.map(el => {
            return el.filter(sel => {
              return !['flex', 'imagemap', 'sticker'].includes(sel.type)
            }, [])
          }, [])
          vm.line_messages2 = cloneDeep(vm.messages2)
          vm.ig_messages2 = cloneDeep(vm.messages2)
          vm.whatsapp_messages2 = cloneDeep(vm.messages2)
          vm.google_messages2 = cloneDeep(vm.messages2)
          vm.ig_messages2 = vm.ig_messages2.map(el => {
            return el.filter(sel => {
              return !['flex', 'imagemap', 'sticker'].includes(sel.type)
            }, [])
          }, [])

          vm.$set(
            vm.wordafter,
            'follow_up_fb_quick_reply',
            vm.wordafter.follow_up_order_quick_reply
          )
          vm.$set(
            vm.wordafter,
            'follow_up_line_quick_reply',
            vm.wordafter.follow_up_order_quick_reply
          )
          vm.$set(
            vm.wordafter,
            'follow_up_ig_quick_reply',
            vm.wordafter.follow_up_order_quick_reply
          )
        }
        vm.showMultipleChannelFollowUp = payload.showMultipleChannel

        if (vm.showMultipleChannelFollowUp) vm.tab2 = 'facebook'
        else vm.tab2 = 'all'
      }
    },
    async changeSetting(payload) {
      const vm = this
      if (
        (vm.$store.getters.getPackage == 'premium' || vm.selectedBot.pagetype == 'enterprise') &&
        payload.hasOwnProperty('showMultipleChannel')
      ) {
        if (
          vm.showMultipleChannel != payload.showMultipleChannel &&
          payload.showMultipleChannel == true
        ) {
          var fb_messages = cloneDeep(vm.messages)
          vm.fb_messages = fb_messages.map(el => {
            return el.filter(sel => {
              return !['flex', 'imagemap', 'sticker'].includes(sel.type)
            }, [])
          }, [])
          vm.line_messages = cloneDeep(vm.messages)
          vm.ig_messages = cloneDeep(vm.messages)
          vm.whatsapp_messages = cloneDeep(vm.messages2)
          vm.google_messages = cloneDeep(vm.messages2)
          vm.ig_messages = vm.ig_messages.map(el => {
            return el.filter(sel => {
              return !['flex', 'imagemap', 'sticker'].includes(sel.type)
            }, [])
          }, [])

          vm.$set(
            vm.wordafter,
            'follow_up_cart_fb_quick_reply',
            vm.wordafter.follow_up_cart_quick_reply
          )
          vm.$set(
            vm.wordafter,
            'follow_up_cart_line_quick_reply',
            vm.wordafter.follow_up_cart_quick_reply
          )
          vm.$set(
            vm.wordafter,
            'follow_up_cart_ig_quick_reply',
            vm.wordafter.follow_up_cart_quick_reply
          )
        }
        vm.showMultipleChannel = payload.showMultipleChannel

        if (vm.showMultipleChannel) vm.tab = 'facebook'
        else vm.tab = 'all'
      }
    },
    checkQuickReply(type, obj) {
      const vm = this
      vm.errorTag[type] = []
      if (obj.tag.text == '') {
      } else if (obj.tag.text.length > 20) {
        vm.errorTag[type].push('overmaxlength')
        obj.error()
      } else if (
        obj.type == 'add' &&
        ((type == 'replies' && vm.follow_up_cart_quick_reply.length >= 10) ||
          (type == 'facebook' && vm.follow_up_cart_fb_quick_reply.length >= 10) ||
          (type == 'line' && vm.follow_up_cart_line_quick_reply.length >= 10) ||
          (type == 'instagram' && vm.follow_up_cart_ig_quick_reply.length >= 10) ||
          (type == 'whatsapp' && vm.follow_up_cart_whatsapp_quick_reply.length >= 10) ||
          (type == 'google' && vm.follow_up_cart_google_quick_reply.length >= 10) ||
          (type == 'follow_up_replies' && vm.follow_up_order_quick_reply.length >= 10) ||
          (type == `follow_up_facebook` && vm.follow_up_order_fb_quick_reply.length >= 10) ||
          (type == `follow_up_line` && vm.follow_up_order_line_quick_reply.length >= 10) ||
          (type == `follow_up_ig` && vm.follow_up_order_ig_quick_reply.length >= 10) ||
          (type == `follow_up_whatsapp` && vm.follow_up_order_whatsapp_quick_reply.length >= 10) ||
          (type == `follow_up_google` && vm.follow_up_order_google_quick_reply.length >= 10))
      ) {
        vm.errorTag[type].push('overtagmax')
        obj.error()
      } else if (obj.tag.isDuplicate) {
        vm.errorTag[type].push('duplicate')
        obj.error()
      } else obj.addTag()
    },

    addReplies: function(type, newTags) {
      const vm = this
      if (type == 'facebook') vm.follow_up_cart_fb_quick_reply = newTags
      else if (type == 'line') vm.follow_up_cart_line_quick_reply = newTags
      else if (type == 'instagram') vm.follow_up_cart_ig_quick_reply = newTags
      else if (type == 'whatsapp') vm.follow_up_cart_whatsapp_quick_reply = newTags
      else if (type == 'google') vm.follow_up_cart_google_quick_reply = newTags
      else vm.follow_up_cart_quick_reply = newTags
    },
    followUpAddReplies: function(type, newTags) {
      const vm = this
      if (type == 'facebook') vm.follow_up_order_fb_quick_reply = newTags
      else if (type == 'line') vm.follow_up_order_line_quick_reply = newTags
      else if (type == 'instagram') vm.follow_up_order_ig_quick_reply = newTags
      else if (type == 'whatsapp') vm.follow_up_order_whatsapp_quick_reply = newTags
      else if (type == 'google') vm.follow_up_order_google_quick_reply = newTags
      else vm.follow_up_order_quick_reply = newTags
    },

    // followUpAddOederReplies: function(newTags) {
    //   this.follow_up_order_quick_reply = newTags
    // },
    async onChangeToggle() {
      this.is_hide_add_more_btn = !this.is_hide_add_more_btn
      this.$store.dispatch('loading')
      var data = {
        body: { is_hide_add_more_btn: this.is_hide_add_more_btn },
        pageId: this.selectedBot.pageid
      }
      var res = await api.toggleWeightShipping(data)
      if (res.success) {
        this.$store.dispatch('updateBotDetail')
      } else {
        this.is_hide_add_more_btn = !this.is_hide_add_more_btn
      }
      this.$store.dispatch('loading')
    },
    resetShopOption() {
      this.$store.dispatch('updateBotDetail').then(() => {
        this.isEditShopOption = false
        if (this.selectedBot.shop_addon_form_json) {
          this.shopOption = JSON.parse(this.selectedBot.shop_addon_form_json)
          this.setShopOption = this.selectedBot.shop_addon_form_status
        }
      })
    },
    setShopOptionToggle() {
      this.setShopOption = !this.setShopOption
      this.saveShopOption()
    },

    async toggleEditAddress() {
      this.EditAddress = !this.EditAddress
      var vm = this
      vm.$store.dispatch('loading')
      var data = {
        pageid: vm.selectedBot.pageid,
        body: {
          is_allow_user_edit_order: vm.EditAddress
        }
      }
      try {
        var response = await api.userEditOrder(data)
        if (response) {
          this.EditAddress = response.result.is_allow_user_edit_order
          vm.$store.dispatch('updateBotDetail')
        }
        vm.$store.dispatch('loading')
      } catch (error) {
        this.EditAddress = !vm.EditAddress
        vm.$store.dispatch('loading')
        vm.$swal.fire({
          type: 'error',
          text: 'มีบางอย่างผิดพลาด ไม่สามารถทำการบันทึกได้'
        })
      }
    },
    async saveShopOption() {
      var vm = this
      vm.$store.dispatch('loading')
      var data = {
        pageid: vm.selectedBot.pageid,
        body: {
          shop_addon_form_status: vm.setShopOption,
          shop_addon_form_json: JSON.stringify(vm.shopOption)
        }
      }
      try {
        var response = await api.putAddonForm(data)
        if (response) {
          vm.isEditShopOption = false
          vm.$store.dispatch('updateBotDetail')
        }
        vm.$store.dispatch('loading')
      } catch (error) {
        vm.$store.dispatch('loading')
        vm.$swal.fire({
          type: 'error',
          text: 'มีบางอย่างผิดพลาด ไม่สามารถทำการบันทึกได้'
        })
      }
    },
    addWordCartSummaryPrefill: function(prefill) {
      var vm = this
      let cursorPosition = vm.$refs.answer_word_cart_summary.$el.selectionStart

      vm.wordafter.wordscartsummary.text = [
        vm.wordafter.wordscartsummary.text.slice(0, cursorPosition),
        '{' + prefill + '}',
        vm.wordafter.wordscartsummary.text.slice(cursorPosition)
      ].join('')
    },
    addWordOrderPrefill: function(prefill) {
      var vm = this
      let cursorPosition = vm.$refs.answer_word_orders.$el.selectionStart
      vm.wordafter.wordsorders.text = [
        vm.wordafter.wordsorders.text.slice(0, cursorPosition),
        '{' + prefill + '}',
        vm.wordafter.wordsorders.text.slice(cursorPosition)
      ].join('')
    },
    onSelectLang: function(val) {
      this.lang = val
      this.profile.shoplang = val.value
    },
    getSetting: function() {
      let vm = this
      var data = {
        pageid: vm.selectedBot.pageid
      }

      api.getSetting(data, function(error, response) {
        if (error) {
          console.error(error)
          return
        }
        vm.contents = {}
        if (response.data) {
          response.data.map(function(setting, index) {
            vm.contents[setting.contenttype] = setting
            if (setting.contenttype === 'allowtransfer') {
              vm.isTransfer = setting.contentvalue
            }
            if (setting.contenttype === 'allowcreditcard') {
              vm.isCreditCard = setting.contentvalue
            }
          })
        }
      })
    },
    getWordAfterOrderAndCartSummary: function() {
      let vm = this
      var data = {
        pageid: vm.selectedBot.pageid
      }
      vm.wordafter.loading = true
      api.getWordAfterOrderAndCartSummary(data, function(error, response) {
        if (error) {
          console.error(error)
          vm.wordafter.loading = false
          return
        }
        if (response.data) {
          vm.wordafter = response.data

          if (
            vm.check_privilege('multichannel') &&
            (vm.wordafter.follow_up_cart_fb_val ||
              vm.wordafter.follow_up_cart_line_val ||
              vm.wordafter.follow_up_cart_ig_val ||
              vm.wordafter.follow_up_cart_whatsapp_val ||
              vm.wordafter.follow_up_cart_google_val)
          ) {
            vm.showMultipleChannel = true
            vm.fb_messages = JSON.parse(vm.wordafter.follow_up_cart_fb_val) || [[]]
            vm.line_messages = JSON.parse(vm.wordafter.follow_up_cart_line_val) || [[]]
            vm.ig_messages = JSON.parse(vm.wordafter.follow_up_cart_ig_val) || [[]]
            // vm.whatsapp_messages = JSON.parse(vm.wordafter.follow_up_cart_whatsapp_val) || [[]]
            vm.google_messages = JSON.parse(vm.wordafter.follow_up_cart_google_val) || [[]]
            vm.tab = 'facebook'
          }

          if (
            vm.check_privilege('multichannel') &&
            (vm.wordafter.follow_up_order_fb_val ||
              vm.wordafter.follow_up_order_line_val ||
              vm.wordafter.follow_up_order_ig_val ||
              vm.wordafter.follow_up_order_whatsapp_val ||
              vm.wordafter.follow_up_order_google_val)
          ) {
            vm.showMultipleChannelFollowUp = true
            vm.fb_messages2 = JSON.parse(vm.wordafter.follow_up_order_fb_val) || [[]]
            vm.line_messages2 = JSON.parse(vm.wordafter.follow_up_order_line_val) || [[]]
            vm.ig_messages2 = JSON.parse(vm.wordafter.follow_up_order_ig_val) || [[]]
            // vm.whatsapp_messages2 = JSON.parse(vm.wordafter.follow_up_order_whatsapp_val) || [[]]
            vm.google_messages2 = JSON.parse(vm.wordafter.follow_up_order_google_val) || [[]]
            vm.tab2 = 'facebook'
          }
          if (response.data.follow_up_cart_val) {
            vm.messages = JSON.parse(response.data.follow_up_cart_val)
          }
          if (response.data.follow_up_order_val) {
            vm.messages2 = JSON.parse(response.data.follow_up_order_val)
          }
          if (response.data.wordscartsummary) {
            vm.wordafter.wordscartsummary = JSON.parse(response.data.wordscartsummary)
          } else {
            vm.wordafter.wordscartsummary = { type: 'text', text: '' }
          }
          if (response.data.wordsorders) {
            vm.wordafter.wordsorders = JSON.parse(response.data.wordsorders)
          } else {
            vm.wordafter.wordsorders = { type: 'text', text: '' }
          }
          if (response.data.buttons_cart_summary) {
            vm.wordafter.buttons_cart_summary = response.data.buttons_cart_summary
          }
          if (typeof vm.wordafter.follow_up_cart_within_seconds !== 'object') {
            vm.wordafter.follow_up_cart_within_seconds = {
              HH: (
                '0' + Math.floor(parseInt(vm.wordafter.follow_up_cart_within_seconds) / 60 / 60)
              ).slice(-2),
              mm: (
                '0' +
                JSON.stringify((parseInt(vm.wordafter.follow_up_cart_within_seconds) / 60) % 60)
              ).slice(-2)
            }
          }
          if (typeof vm.wordafter.follow_up_cart_fb_within_seconds !== 'object') {
            vm.wordafter.follow_up_cart_fb_within_seconds = {
              HH: (
                '0' + Math.floor(parseInt(vm.wordafter.follow_up_cart_fb_within_seconds) / 60 / 60)
              ).slice(-2),
              mm: (
                '0' +
                JSON.stringify((parseInt(vm.wordafter.follow_up_cart_fb_within_seconds) / 60) % 60)
              ).slice(-2)
            }
          }
          if (typeof vm.wordafter.follow_up_cart_line_within_seconds !== 'object') {
            vm.wordafter.follow_up_cart_line_within_seconds = {
              HH: (
                '0' +
                Math.floor(parseInt(vm.wordafter.follow_up_cart_line_within_seconds) / 60 / 60)
              ).slice(-2),
              mm: (
                '0' +
                JSON.stringify(
                  (parseInt(vm.wordafter.follow_up_cart_line_within_seconds) / 60) % 60
                )
              ).slice(-2)
            }
          }
          if (typeof vm.wordafter.follow_up_cart_ig_within_seconds !== 'object') {
            vm.wordafter.follow_up_cart_ig_within_seconds = {
              HH: (
                '0' + Math.floor(parseInt(vm.wordafter.follow_up_cart_ig_within_seconds) / 60 / 60)
              ).slice(-2),
              mm: (
                '0' +
                JSON.stringify((parseInt(vm.wordafter.follow_up_cart_ig_within_seconds) / 60) % 60)
              ).slice(-2)
            }
          }
          if (typeof vm.wordafter.follow_up_cart_google_within_seconds !== 'object') {
            vm.wordafter.follow_up_cart_google_within_seconds = {
              HH: (
                '0' +
                Math.floor(parseInt(vm.wordafter.follow_up_cart_google_within_seconds) / 60 / 60)
              ).slice(-2),
              mm: (
                '0' +
                JSON.stringify(
                  (parseInt(vm.wordafter.follow_up_cart_google_within_seconds) / 60) % 60
                )
              ).slice(-2)
            }
          }
          if (typeof vm.wordafter.follow_up_order_within_seconds !== 'object') {
            vm.wordafter.follow_up_order_within_seconds = {
              HH: (
                '0' + Math.floor(parseInt(vm.wordafter.follow_up_order_within_seconds) / 60 / 60)
              ).slice(-2),
              mm: (
                '0' +
                JSON.stringify((parseInt(vm.wordafter.follow_up_order_within_seconds) / 60) % 60)
              ).slice(-2)
            }
          }
          if (typeof vm.wordafter.follow_up_order_fb_within_seconds !== 'object') {
            vm.wordafter.follow_up_order_fb_within_seconds = {
              HH: (
                '0' + Math.floor(parseInt(vm.wordafter.follow_up_order_fb_within_seconds) / 60 / 60)
              ).slice(-2),
              mm: (
                '0' +
                JSON.stringify((parseInt(vm.wordafter.follow_up_order_fb_within_seconds) / 60) % 60)
              ).slice(-2)
            }
          }
          if (typeof vm.wordafter.follow_up_order_line_within_seconds !== 'object') {
            vm.wordafter.follow_up_order_line_within_seconds = {
              HH: (
                '0' +
                Math.floor(parseInt(vm.wordafter.follow_up_order_line_within_seconds) / 60 / 60)
              ).slice(-2),
              mm: (
                '0' +
                JSON.stringify(
                  (parseInt(vm.wordafter.follow_up_order_line_within_seconds) / 60) % 60
                )
              ).slice(-2)
            }
          }
          if (typeof vm.wordafter.follow_up_order_ig_within_seconds !== 'object') {
            vm.wordafter.follow_up_order_ig_within_seconds = {
              HH: (
                '0' + Math.floor(parseInt(vm.wordafter.follow_up_order_ig_within_seconds) / 60 / 60)
              ).slice(-2),
              mm: (
                '0' +
                JSON.stringify((parseInt(vm.wordafter.follow_up_order_ig_within_seconds) / 60) % 60)
              ).slice(-2)
            }
          }
          if (typeof vm.wordafter.follow_up_order_google_within_seconds !== 'object') {
            vm.wordafter.follow_up_order_google_within_seconds = {
              HH: (
                '0' +
                Math.floor(parseInt(vm.wordafter.follow_up_order_google_within_seconds) / 60 / 60)
              ).slice(-2),
              mm: (
                '0' +
                JSON.stringify(
                  (parseInt(vm.wordafter.follow_up_order_google_within_seconds) / 60) % 60
                )
              ).slice(-2)
            }
          }
        }
        vm.cached_buttons_cart_summary = JSON.stringify(vm.wordafter.buttons_cart_summary)
        vm.cached_wordscartsummary = JSON.stringify(vm.wordafter.wordscartsummary)
        vm.cached_wordsorders = JSON.stringify(vm.wordafter.wordsorders)
        vm.wordafter.loading = false
      })
    },
    cancelEditWordAfterOrderAndCartSummary: function() {
      var vm = this
      vm.wordafter.buttons_cart_summary = JSON.parse(vm.cached_buttons_cart_summary)
      vm.wordafter.wordscartsummary = JSON.parse(vm.cached_wordscartsummary)
      vm.wordafter.wordsorders = JSON.parse(vm.cached_wordsorders)
      vm.isEditOrderSummaryMessage = false
    },
    saveWordAfterOrderAndCartSummary: function() {
      const vm = this
      if (vm.showMultipleChannel) {
        //line
        if (vm.wordafter.follow_up_cart_line_within_seconds) {
          vm.wordafter.follow_up_cart_line_within_seconds.HH = vm.wordafter
            .follow_up_cart_line_within_seconds_date
            ? Number(vm.wordafter.follow_up_cart_line_within_seconds_date) * 24 +
              parseInt(vm.wordafter.follow_up_cart_line_within_seconds.HH)
            : '00'
          vm.wordafter.follow_up_cart_line_within_seconds.mm = vm.wordafter
            .follow_up_cart_line_within_seconds.mm
            ? vm.wordafter.follow_up_cart_line_within_seconds.mm
            : '00'
        } else {
          vm.wordafter.follow_up_cart_line_within_seconds = null
        }
        //fb
        if (vm.wordafter.follow_up_cart_fb_within_seconds) {
          vm.wordafter.follow_up_cart_fb_within_seconds.HH = vm.wordafter
            .follow_up_cart_fb_within_seconds.HH
            ? vm.wordafter.follow_up_cart_fb_within_seconds.HH
            : '00'
          vm.wordafter.follow_up_cart_fb_within_seconds.mm = vm.wordafter
            .follow_up_cart_fb_within_seconds.mm
            ? vm.wordafter.follow_up_cart_fb_within_seconds.mm
            : '00'
        }
        //ig
        if (vm.wordafter.follow_up_cart_ig_within_seconds) {
          vm.wordafter.follow_up_cart_ig_within_seconds.HH = vm.wordafter
            .follow_up_cart_ig_within_seconds.HH
            ? vm.wordafter.follow_up_cart_ig_within_seconds.HH
            : '00'
          vm.wordafter.follow_up_cart_ig_within_seconds.mm = vm.wordafter
            .follow_up_cart_ig_within_seconds.mm
            ? vm.wordafter.follow_up_cart_ig_within_seconds.mm
            : '00'
        }
        //google
        if (vm.wordafter.follow_up_cart_google_within_seconds) {
          vm.wordafter.follow_up_cart_google_within_seconds.HH = vm.wordafter
            .follow_up_cart_google_within_seconds.HH
            ? vm.wordafter.follow_up_cart_google_within_seconds.HH
            : '00'
          vm.wordafter.follow_up_cart_google_within_seconds.mm = vm.wordafter
            .follow_up_cart_google_within_seconds.mm
            ? vm.wordafter.follow_up_cart_google_within_seconds.mm
            : '00'
        }
        vm.wordafter.follow_up_cart_within_seconds = null
      } else {
        if (typeof vm.wordafter.follow_up_cart_within_seconds === 'string') {
          vm.wordafter.follow_up_cart_within_seconds = {
            mm: '00',
            HH: '00'
          }
        }
        vm.wordafter.follow_up_cart_within_seconds.HH = vm.wordafter.follow_up_cart_within_seconds
          .HH
          ? vm.wordafter.follow_up_cart_within_seconds.HH
          : '00'
        vm.wordafter.follow_up_cart_within_seconds.mm = vm.wordafter.follow_up_cart_within_seconds
          .mm
          ? vm.wordafter.follow_up_cart_within_seconds.mm
          : '00'
        vm.wordafter.follow_up_cart_line_within_seconds = null
        vm.wordafter.follow_up_cart_fb_within_seconds = null
        vm.wordafter.follow_up_cart_ig_within_seconds = null
        vm.wordafter.follow_up_cart_google_within_seconds = null
      }
      if (vm.showMultipleChannelFollowUp) {
        //line
        if (vm.wordafter.follow_up_order_line_within_seconds) {
          vm.wordafter.follow_up_order_line_within_seconds.HH = vm.wordafter
            .follow_up_order_line_within_seconds_date
            ? Number(vm.wordafter.follow_up_order_line_within_seconds_date) * 24 +
              parseInt(vm.wordafter.follow_up_order_line_within_seconds.HH)
            : '00'
          vm.wordafter.follow_up_order_line_within_seconds.mm = vm.wordafter
            .follow_up_order_line_within_seconds.mm
            ? vm.wordafter.follow_up_order_line_within_seconds.mm
            : '00'
        } else {
          vm.wordafter.follow_up_order_line_within_seconds = null
        }
        //fb
        if (vm.wordafter.follow_up_order_fb_within_seconds) {
          vm.wordafter.follow_up_order_fb_within_seconds.HH = vm.wordafter
            .follow_up_order_fb_within_seconds.HH
            ? vm.wordafter.follow_up_order_fb_within_seconds.HH
            : '00'
          vm.wordafter.follow_up_order_fb_within_seconds.mm = vm.wordafter
            .follow_up_order_fb_within_seconds.mm
            ? vm.wordafter.follow_up_order_fb_within_seconds.mm
            : '00'
        }
        //ig
        if (vm.wordafter.follow_up_order_ig_within_seconds) {
          vm.wordafter.follow_up_order_ig_within_seconds.HH = vm.wordafter
            .follow_up_order_ig_within_seconds.HH
            ? vm.wordafter.follow_up_order_ig_within_seconds.HH
            : '00'
          vm.wordafter.follow_up_order_ig_within_seconds.mm = vm.wordafter
            .follow_up_order_ig_within_seconds.mm
            ? vm.wordafter.follow_up_order_ig_within_seconds.mm
            : '00'
        }
        //google
        if (vm.wordafter.follow_up_order_google_within_seconds) {
          vm.wordafter.follow_up_order_google_within_seconds.HH = vm.wordafter
            .follow_up_order_google_within_seconds.HH
            ? vm.wordafter.follow_up_order_google_within_seconds.HH
            : '00'
          vm.wordafter.follow_up_order_google_within_seconds.mm = vm.wordafter
            .follow_up_order_google_within_seconds.mm
            ? vm.wordafter.follow_up_order_google_within_seconds.mm
            : '00'
        }
        vm.wordafter.follow_up_cart_within_seconds = null
      } else {
        if (typeof vm.wordafter.follow_up_order_within_seconds === 'string') {
          vm.wordafter.follow_up_order_within_seconds = {
            mm: '00',
            HH: '00'
          }
        }
        vm.wordafter.follow_up_order_within_seconds.HH = vm.wordafter.follow_up_order_within_seconds
          .HH
          ? vm.wordafter.follow_up_order_within_seconds.HH
          : '00'
        vm.wordafter.follow_up_order_within_seconds.mm = vm.wordafter.follow_up_order_within_seconds
          .mm
          ? vm.wordafter.follow_up_order_within_seconds.mm
          : '00'
        vm.wordafter.follow_up_cart_line_within_seconds = null
        vm.wordafter.follow_up_cart_fb_within_seconds = null
        vm.wordafter.follow_up_cart_ig_within_seconds = null
        vm.wordafter.follow_up_cart_google_within_seconds = null
      }

      vm.$store.dispatch('loading')
      let data = {
        buttons_cart_summary: JSON.stringify(vm.wordafter.buttons_cart_summary),
        wordscartsummary: JSON.stringify(vm.wordafter.wordscartsummary),
        wordsorders: JSON.stringify(vm.wordafter.wordsorders),
        pageid: vm.selectedBot.pageid,
        follow_up_cart_quick_reply: vm.wordafter.follow_up_cart_quick_reply,
        follow_up_order_quick_reply: vm.wordafter.follow_up_order_quick_reply,
        follow_up_cart_status: vm.wordafter.follow_up_cart_status,
        follow_up_order_status: vm.wordafter.follow_up_order_status,
        follow_up_cart_within_seconds: vm.wordafter.follow_up_cart_within_seconds
          ? (parseInt(vm.wordafter.follow_up_cart_within_seconds.HH) * 60 +
              parseInt(
                vm.wordafter.follow_up_cart_within_seconds.mm.substring(0, 1) == 0
                  ? vm.wordafter.follow_up_cart_within_seconds.mm.substring(1)
                  : vm.wordafter.follow_up_cart_within_seconds.mm
              )) *
            60
          : null,
        follow_up_cart_fb_within_seconds: vm.wordafter.follow_up_cart_fb_within_seconds
          ? (parseInt(vm.wordafter.follow_up_cart_fb_within_seconds.HH) * 60 +
              parseInt(
                vm.wordafter.follow_up_cart_fb_within_seconds.mm.substring(0, 1) == 0
                  ? vm.wordafter.follow_up_cart_fb_within_seconds.mm.substring(1)
                  : vm.wordafter.follow_up_cart_fb_within_seconds.mm
              )) *
            60
          : null,
        follow_up_cart_line_within_seconds: vm.wordafter.follow_up_cart_line_within_seconds
          ? (parseInt(vm.wordafter.follow_up_cart_line_within_seconds.HH) * 60 +
              parseInt(
                vm.wordafter.follow_up_cart_line_within_seconds.mm.substring(0, 1) == 0
                  ? vm.wordafter.follow_up_cart_line_within_seconds.mm.substring(1)
                  : vm.wordafter.follow_up_cart_line_within_seconds.mm
              )) *
            60
          : null,
        follow_up_cart_ig_within_seconds: vm.wordafter.follow_up_cart_ig_within_seconds
          ? (parseInt(vm.wordafter.follow_up_cart_ig_within_seconds.HH) * 60 +
              parseInt(
                vm.wordafter.follow_up_cart_ig_within_seconds.mm.substring(0, 1) == 0
                  ? vm.wordafter.follow_up_cart_ig_within_seconds.mm.substring(1)
                  : vm.wordafter.follow_up_cart_ig_within_seconds.mm
              )) *
            60
          : null,
        follow_up_cart_google_within_seconds: vm.wordafter.follow_up_cart_google_within_seconds
          ? (parseInt(vm.wordafter.follow_up_cart_google_within_seconds.HH) * 60 +
              parseInt(
                vm.wordafter.follow_up_cart_google_within_seconds.mm.substring(0, 1) == 0
                  ? vm.wordafter.follow_up_cart_google_within_seconds.mm.substring(1)
                  : vm.wordafter.follow_up_cart_google_within_seconds.mm
              )) *
            60
          : null,
        follow_up_order_within_seconds: vm.wordafter.follow_up_order_within_seconds
          ? (parseInt(vm.wordafter.follow_up_order_within_seconds.HH) * 60 +
              parseInt(
                vm.wordafter.follow_up_order_within_seconds.mm.substring(0, 1) == 0
                  ? vm.wordafter.follow_up_order_within_seconds.mm.substring(1)
                  : vm.wordafter.follow_up_order_within_seconds.mm
              )) *
            60
          : null,
        follow_up_order_fb_within_seconds: vm.wordafter.follow_up_order_fb_within_seconds
          ? (parseInt(vm.wordafter.follow_up_order_fb_within_seconds.HH) * 60 +
              parseInt(
                vm.wordafter.follow_up_order_fb_within_seconds.mm.substring(0, 1) == 0
                  ? vm.wordafter.follow_up_order_fb_within_seconds.mm.substring(1)
                  : vm.wordafter.follow_up_order_fb_within_seconds.mm
              )) *
            60
          : null,
        follow_up_order_line_within_seconds: vm.wordafter.follow_up_order_line_within_seconds
          ? (parseInt(vm.wordafter.follow_up_order_line_within_seconds.HH) * 60 +
              parseInt(
                vm.wordafter.follow_up_order_line_within_seconds.mm.substring(0, 1) == 0
                  ? vm.wordafter.follow_up_order_line_within_seconds.mm.substring(1)
                  : vm.wordafter.follow_up_order_line_within_seconds.mm
              )) *
            60
          : null,
        follow_up_order_ig_within_seconds: vm.wordafter.follow_up_order_ig_within_seconds
          ? (parseInt(vm.wordafter.follow_up_order_ig_within_seconds.HH) * 60 +
              parseInt(
                vm.wordafter.follow_up_order_ig_within_seconds.mm.substring(0, 1) == 0
                  ? vm.wordafter.follow_up_order_ig_within_seconds.mm.substring(1)
                  : vm.wordafter.follow_up_order_ig_within_seconds.mm
              )) *
            60
          : null,
        follow_up_order_google_within_seconds: vm.wordafter.follow_up_order_google_within_seconds
          ? (parseInt(vm.wordafter.follow_up_order_google_within_seconds.HH) * 60 +
              parseInt(
                vm.wordafter.follow_up_order_google_within_seconds.mm.substring(0, 1) == 0
                  ? vm.wordafter.follow_up_order_google_within_seconds.mm.substring(1)
                  : vm.wordafter.follow_up_order_google_within_seconds.mm
              )) *
            60
          : null,
        follow_up_cart_val: JSON.stringify(vm.checkEmptyMessage(vm.messages)),
        follow_up_order_val: JSON.stringify(vm.checkEmptyMessage(vm.messages2)),
        follow_up_cart_type: 'json',
        follow_up_order_type: 'json'
      }

      if (this.showMultipleChannel) {
        data.follow_up_cart_fb_val = JSON.stringify(vm.fb_messages).replace(/ /gim, ' ')
        data.follow_up_cart_line_val = JSON.stringify(vm.line_messages).replace(/ /gim, ' ')
        data.follow_up_cart_ig_val = JSON.stringify(vm.ig_messages).replace(/ /gim, ' ')
        data.follow_up_cart_whatsapp_val = JSON.stringify(vm.whatsapp_messages).replace(/ /gim, ' ')
        data.follow_up_cart_google_val = JSON.stringify(vm.google_messages).replace(/ /gim, ' ')
        data.follow_up_cart_whatsapp_val = JSON.stringify(vm.whatsapp_messages).replace(/ /gim, ' ')
        data.follow_up_cart_fb_quick_reply = vm.wordafter.follow_up_cart_fb_quick_reply
        data.follow_up_cart_line_quick_reply = vm.wordafter.follow_up_cart_line_quick_reply
        data.follow_up_cart_ig_quick_reply = vm.wordafter.follow_up_cart_ig_quick_reply
        data.follow_up_cart_whatsapp_quick_reply = vm.wordafter.follow_up_cart_whatsapp_quick_reply
        data.follow_up_cart_google_quick_reply = vm.wordafter.follow_up_cart_google_quick_reply
        data.follow_up_cart_whatsapp_quick_reply = vm.wordafter.follow_up_cart_whatsapp_quick_reply
      }

      if (this.showMultipleChannelFollowUp) {
        data.follow_up_order_fb_val = JSON.stringify(vm.fb_messages2).replace(/ /gim, ' ')
        data.follow_up_order_line_val = JSON.stringify(vm.line_messages2).replace(/ /gim, ' ')
        data.follow_up_order_ig_val = JSON.stringify(vm.ig_messages2).replace(/ /gim, ' ')
        data.follow_up_order_whatsapp_val = JSON.stringify(vm.whatsapp_messages2).replace(
          / /gim,
          ' '
        )
        data.follow_up_order_google_val = JSON.stringify(vm.google_messages2).replace(/ /gim, ' ')
        data.follow_up_order_whatsapp_val = JSON.stringify(vm.whatsapp_messages2).replace(
          / /gim,
          ' '
        )
        data.follow_up_order_fb_quick_reply = vm.wordafter.follow_up_order_fb_quick_reply
        data.follow_up_order_line_quick_reply = vm.wordafter.follow_up_order_line_quick_reply
        data.follow_up_order_ig_quick_reply = vm.wordafter.follow_up_order_ig_quick_reply
        data.follow_up_order_whatsapp_quick_reply =
          vm.wordafter.follow_up_order_whatsapp_quick_reply
        data.follow_up_order_google_quick_reply = vm.wordafter.follow_up_order_google_quick_reply
        data.follow_up_order_whatsapp_quick_reply =
          vm.wordafter.follow_up_order_whatsapp_quick_reply
      }

      vm.$validator.validate().then(result => {
        if (!result) {
          // do stuff if not valid.
          vm.goToErrorInput()
          return false
        }

        // vm.wordafter.loading = true
        api.saveWordAfterOrderAndCartSummary(data, function(error, response) {
          if (error) {
            console.error(error)
            vm.$store.dispatch('loading')
            // vm.wordafter.loading = false
            return
          }
          vm.cached_buttons_cart_summary = JSON.stringify(vm.wordafter.buttons_cart_summary)
          vm.cached_wordscartsummary = JSON.stringify(vm.wordafter.wordscartsummary)
          vm.cached_wordsorders = JSON.stringify(vm.wordafter.wordsorders)
          // vm.wordafter.loading = false
          vm.$store.dispatch('loading')
          vm.isEditOrderSummaryMessage = false
        })
      })
    },
    getShopProfile: function() {
      let data = {
        pageid: this.selectedBot.pageid
      }
      let vm = this
      api.getShopProfile(data, function(error, response) {
        if (error) {
          console.error(error)

          return
        }
        if (response.shopprofile) {
          vm.profile = {
            pageaddress: response.shopprofile.pageaddress,
            description: response.shopprofile.description,
            pageshortlink: response.shopprofile.pageshortlink,
            pagename: response.shopprofile.pagename,
            shoplang: response.shopprofile.shoplang,
            shopcolor: response.shopprofile.shopcolor
          }
          vm.oldProfile = {
            pageaddress: response.shopprofile.pageaddress,
            description: response.shopprofile.description,
            pageshortlink: response.shopprofile.pageshortlink,
            pagename: response.shopprofile.pagename,
            shoplang: response.shopprofile.shoplang,
            shopcolor: response.shopprofile.shopcolor
          }
          var findLang = vm.langOptions.find(function(el) {
            return el.value == response.shopprofile.shoplang
          })

          if (findLang) {
            vm.lang = findLang
          } else {
            vm.lang = vm.langOptions[1]
          }

          vm.color = response.shopprofile.shopcolor ? response.shopprofile.shopcolor : '#1CA085'
        }
      })
    },
    saveProfile: function() {
      let vm = this
      let data = {
        description: vm.profile.description != null ? vm.profile.description : '',
        pageaddress: vm.profile.pageaddress != null ? vm.profile.pageaddress : '',
        pageid: vm.selectedBot.pageid,
        pageshortlink: vm.profile.pageshortlink != null ? vm.profile.pageshortlink : vm.pageid
      }
      if (vm.$store.getters.getPackage == 'premium') {
        data.shoplang = vm.profile.shoplang
        data.shopcolor = vm.color
      }

      vm.$validator.validate().then(result => {
        if (!result) {
          // do stuff if not valid.
          vm.goToErrorInput()
          return false
        }
        api.editShopProfile(data, function(error, response) {
          if (error) {
            console.error(error)
            return
          }
          vm.isEditShop = false
          vm.oldProfile.description = vm.profile.description
          vm.oldProfile.pageaddress = vm.profile.pageaddress
          vm.oldProfile.pageshortlink = vm.profile.pageshortlink
        })
      })
    },

    resetPageShortLink: function() {
      if (!this.selectedBot.pageid || this.selectedBot.pageid == null) {
        return false
      }
      this.isChangeShortlink = true
      this.profile.pageshortlink = this.selectedBot.pageid
    },
    cancelEditProfile: function() {
      var vm = this
      this.profile.description = this.oldProfile.description
      this.profile.pageaddress = this.oldProfile.pageaddress
      this.profile.pageshortlink = this.oldProfile.pageshortlink
      var findLang = vm.langOptions.find(function(el) {
        return el.value == vm.oldProfile.shoplang
      })

      if (findLang) {
        vm.lang = findLang
      } else {
        vm.lang = vm.langOptions[1]
      }
      this.isEditShop = false
    },
    getPaypalUrl: function() {
      var vm = this
      vm.paypal.loading = true
      var data = []
      api.getPaypalUrl(data, function(error, response) {
        if (error) {
          console.error(error)
          return
        }
        vm.paypal.paypal_url = response.data.links[1].href
        document.getElementById('actionId').href = vm.paypal.paypal_url + '&displayMode=minibrowser'
        vm.paypal.tracking_id = response.tracking_id
        vm.paypal.loading = false
      })
    },
    registerPaypalMerchant: function() {
      var vm = this

      document.getElementById('actionId').click()

      vm.$store.dispatch('updatePaypalTrackingId', vm.paypal.tracking_id)

      vm.paypal.haveTrackingId = true
      vm.paypal.checkTracking = true
      vm.onRefreshTrackingStatus()
    },
    cancelRegisterPaypalMerchant: function() {
      var vm = this
      if (vm.paypal.checkingInterval != null) {
        clearInterval(vm.paypal.checkingInterval)
      }
      this.getPaypalUrl()
      this.paypal.haveTrackingId = false
      this.paypal.checkTracking = false
      vm.$store.dispatch('updatePaypalTrackingId', null)
    },
    onRefreshTrackingStatus: function() {
      var vm = this
      vm.paypal.checkingTime = 6
      vm.paypal.checkTracking = true

      vm.checkingTrackingStatus(function(status) {
        if (status) {
          clearInterval(vm.paypal.checkingInterval)
          vm.paypal.checkTracking = false
        } else {
          vm.paypal.checkingInterval = setInterval(() => {
            vm.checkingTrackingStatus(function(status) {
              if (vm.paypal.checkingTime === 0 || status) {
                clearInterval(vm.paypal.checkingInterval)
                vm.paypal.checkTracking = false
              }
              vm.paypal.checkingTime--
            })
          }, vm.paypal.checkingTimePerInterval)
        }
      })
    },
    checkingTrackingStatus: function(callback) {
      var vm = this
      var data = {
        tracking_id: vm.paypalTrackingId
      }
      api.getPaypalTrackingStatus(data, function(error, response) {
        if (error) {
          console.error(error)
          return
        }

        if (response.status === 'pending') {
          callback(false)
        } else if (
          response.status === 'success' &&
          response.merchant_id !== '' &&
          response.merchant_id != null
        ) {
          data = {
            pageid: vm.selectedBot.pageid,
            paypal_merchantid: response.merchant_id
          }
          api.updatePaypalMerchantId(data, function(error, response) {
            if (error) {
              console.error(error)
              return
            }
            vm.contents.allowcreditcard.contentvalue = true

            vm.$store.dispatch('updateMerchantId', data.paypal_merchantid)

            callback(true)
          })
        }
      })
    }
  }
}
</script>

<style scoped>
@media only screen and (min-width: 600px) {
  .border-right {
    border-right: 1px solid #eee;
  }
  .line-followup {
    padding: 0.3em 0;
  }
  .line-followup:active,
  .line-followup:hover,
  .line-followup:focus {
    background-color: #41b883;
    color: #fff;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/Payment.vue